import { render, staticRenderFns } from "./ModalSkillForm.vue?vue&type=template&id=1b8fb84e&"
import script from "./ModalSkillForm.vue?vue&type=script&lang=js&"
export * from "./ModalSkillForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports